'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BibTitle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _utilsLink = require('@bibliocommons/utils-link');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _sharedBibSubtitle = require('@bibliocommons/shared-bib-subtitle');

var _sharedBibSubtitle2 = _interopRequireDefault(_sharedBibSubtitle);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _utilsString = require('@bibliocommons/utils-string');

require('../styles/BibTitle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BibTitle = exports.BibTitle = function (_BcReactComponent) {
  _inherits(BibTitle, _BcReactComponent);

  function BibTitle(props) {
    _classCallCheck(this, BibTitle);

    var _this = _possibleConstructorReturn(this, (BibTitle.__proto__ || Object.getPrototypeOf(BibTitle)).call(this, props));

    _this.bindAll('focusOnTitle');
    return _this;
  }

  _createClass(BibTitle, [{
    key: 'focusOnTitle',
    value: function focusOnTitle() {
      if (this._title) {
        this._title.focus();
      }
    }
  }, {
    key: 'formatText',
    value: function formatText(text) {
      var truncateOptions = this.props.truncateOptions;

      return truncateOptions ? (0, _utilsString.truncate)(text, truncateOptions) : text;
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var _this2 = this;

      var _props = this.props,
          renderAsLink = _props.renderAsLink,
          id = _props.id,
          target = _props.target,
          primaryLanguage = _props.primaryLanguage,
          multiscriptTitle = _props.multiscriptTitle,
          title = _props.title,
          format = _props.format,
          intl = _props.intl;

      var titleContent = multiscriptTitle || title;
      var formattedTitleContent = this.formatText(titleContent);

      if (renderAsLink) {
        return _react2.default.createElement(
          'a',
          {
            href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(id),
            target: target,
            lang: primaryLanguage,
            rel: 'noopener',
            ref: function ref(el) {
              return _this2._title = el;
            },
            'data-test-id': 'bib-title-' + id,
            'data-key': 'bib-title' },
          _react2.default.createElement(
            'span',
            { 'aria-hidden': 'true', className: 'title-content' },
            formattedTitleContent
          ),
          _react2.default.createElement(
            _reactIntl.FormattedMessage,
            { id: 'ada_link_to_item_page', values: { title: titleContent, format: intl.formatMessage({ id: 'FORMAT.' + format.toLowerCase() }) } },
            function (message) {
              return _react2.default.createElement(
                _baseScreenReaderMessage2.default,
                null,
                message
              );
            }
          )
        );
      }

      return _react2.default.createElement(
        'div',
        {
          lang: primaryLanguage,
          'data-test-id': 'bib-title-' + id,
          ref: function ref(el) {
            return _this2._title = el;
          },
          tabIndex: '-1' },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true', className: 'title-content' },
          formattedTitleContent
        ),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          title
        )
      );
    }
  }, {
    key: 'renderSecondaryTitle',
    value: function renderSecondaryTitle() {
      var _props2 = this.props,
          multiscriptTitle = _props2.multiscriptTitle,
          title = _props2.title;


      if (title && multiscriptTitle) {
        return _react2.default.createElement(
          'div',
          { className: 'secondary-title' },
          _react2.default.createElement(
            'span',
            { 'aria-hidden': 'true' },
            this.formatText(title)
          ),
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            title
          )
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          subtitle = _props3.subtitle,
          titleTag = _props3.titleTag,
          renderIcon = _props3.renderIcon;

      var TitleTag = titleTag; // This needs to start with an uppercase letter since its a component

      return _react2.default.createElement(
        TitleTag,
        { className: 'cp-title' },
        this.renderTitle(),
        renderIcon(),
        this.renderSecondaryTitle(),
        _react2.default.createElement(_sharedBibSubtitle2.default, { subtitle: subtitle, titleTag: 'span' })
      );
    }
  }]);

  return BibTitle;
}(_baseBcReactComponent2.default);

BibTitle.defaultProps = {
  primaryLanguage: 'en',
  titleTag: 'h2',
  target: '_parent',
  renderAsLink: true,
  renderIcon: function renderIcon() {
    return null;
  }
};

BibTitle.propTypes = {
  id: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  format: _react.PropTypes.string.isRequired,
  subtitle: _react.PropTypes.string,
  titleTag: _react.PropTypes.string,
  target: _react.PropTypes.string,
  multiscriptTitle: _react.PropTypes.string,
  primaryLanguage: _react.PropTypes.string.isRequired,
  renderAsLink: _react.PropTypes.bool,
  renderIcon: _react.PropTypes.func,
  truncateOptions: _bcPropTypes.truncateOptionsShape,
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(BibTitle, { withRef: true });


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-title/lib/components/BibTitle.component.js
// module id = 1476
// module chunks = 1